<template>
  <div v-if="user">
    <h1>{{ user.username }}</h1>
    <div class="stack-sm">
      <input-check
        v-for="(role, index) in roles"
        :key="index"
        :value="isChecked(role.name)"
        :label="role.name"
        @update-value="updateRoleValues(role, $event)"
      />
      <div class="text-right">
        <wd-button @input="submit(formOptions)">{{ $t('general.update') }}</wd-button>
      </div>
    </div>
  </div>
</template>

<script>
import FormMixin from "@/mixins/FormMixin";
const InputCheck = require("@/modules/input/components/InputCheck.vue").default;

export default {
  name: "UserRolesSite",
  mixins: [FormMixin],
  data() {
    return {
      user: null,
      roles: null
    };
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    InputCheck
  },
  methods: {
    isChecked(Role) {
      return this.user ? this.user.roles.includes(Role) : false;
    },
    updateRoleValues(Role, Bool) {
      if (Bool === true) {
        this.formData.roles.push(Role.name);
      } else {
        this.formData.roles = this.formData.roles.filter(e => e !== Role.name);
      }
    }
  },
  computed: {},
  async created() {
    this.user = await this.$store.getters["user/api"].Show(this.id);
    this.roles = await this.$store.getters["roles/api"].GetAll();

    this.formData.roles = this.user.roles;

    this.formOptions = {
      async: true,
      type: "user",
      call: "update",
      id: this.id,
      action: response => {
        this.goTo("/users");
        this.popup({
          title: this.$t("users.user_roles_updated")
        });
      }
    };
  }
};
</script>